import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Box,
  Typography,
  TextField,
  IconButton,
  Button,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import Swal from "sweetalert2";

import { UpdateUser } from "../utils/usersAPI";
import { setLoggedUser } from "../features/userSlice";

const UserDetailsSection = () => {

  const dispatch = useDispatch();
  const loggedUser = useSelector((state) => state.user.logedUser);

  const [isEditing, setIsEditing] = useState(false);
  const [userForm, setUserForm] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
  });

  // כשנטען המשתמש מהרדאקס – למלא את הטופס
  useEffect(() => {
    if (loggedUser) {
      setUserForm({
        name: loggedUser.name || "",
        email: loggedUser.email || "",
        phone: loggedUser.phone || "",
        address: loggedUser.address || "",
      });
    }
  }, [loggedUser]);

  const handleUserFieldChange = (e) => {
    const { name, value } = e.target;
    setUserForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleStartEdit = () => {
    setIsEditing(true);
  };

  const handleCancelEdit = () => {
    if (loggedUser) {
      setUserForm({
        name: loggedUser.name || "",
        email: loggedUser.email || "",
        phone: loggedUser.phone || "",
        address: loggedUser.address || "",
      });
    }
    setIsEditing(false);
  };

  const handleSave = async () => {
    try {
      const updatedUser = {
        ...loggedUser,
        name: userForm.name,
        email: userForm.email,
        phone: userForm.phone,
        address: userForm.address,
      };

      const res = await UpdateUser(loggedUser.id, updatedUser);

      // אם ה-API מחזיר את המשתמש המעודכן – אפשר res.data
      // dispatch(setLoggedUser(res.data));
      dispatch(setLoggedUser(updatedUser));

      Swal.fire({
        title: "הפרטים עודכנו בהצלחה",
        icon: "success",
        timer: 2000,
        showConfirmButton: false,
      });

      setIsEditing(false);
    } catch (err) {
      console.error("שגיאה בעדכון פרטי המשתמש:", err);
      Swal.fire({
        title: "שגיאה בעדכון פרטי המשתמש",
        icon: "error",
      });
    }
  };

  if (!loggedUser) return null;

  return (
    <Box sx={{ mb: 3 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 1,
        }}
      >
        <Typography variant="h6">פרטי לקוח</Typography>

        {!isEditing ? (
          <IconButton size="small" onClick={handleStartEdit}>
            <EditIcon fontSize="small" />
          </IconButton>
        ) : (
          <IconButton size="small" onClick={handleCancelEdit}>
            <CloseIcon fontSize="small" />
          </IconButton>
        )}
      </Box>

      {!isEditing && (
        <>
          <Typography>שם: {loggedUser.name}</Typography>
          <Typography>אימייל: {loggedUser.email}</Typography>
          <Typography>טלפון: {loggedUser.phone}</Typography>
          <Typography>כתובת למשלוח: {loggedUser.address}</Typography>
        </>
      )}

      {isEditing && (
        <Box sx={{ display: "grid", gap: 1 }}>
          <TextField
            label="שם"
            name="name"
            value={userForm.name}
            onChange={handleUserFieldChange}
            fullWidth
          />
          <TextField
            label="אימייל"
            name="email"
            type="email"
            value={userForm.email}
            onChange={handleUserFieldChange}
            fullWidth
          />
          <TextField
            label="טלפון"
            name="phone"
            value={userForm.phone}
            onChange={handleUserFieldChange}
            fullWidth
          />
          <TextField
            label="כתובת למשלוח"
            name="address"
            value={userForm.address}
            onChange={handleUserFieldChange}
            fullWidth
          />

          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 1 }}>
            <Button variant="outlined" onClick={handleCancelEdit}>
              ביטול
            </Button>
            <Button variant="contained" onClick={handleSave}>
              שמור פרטים
            </Button>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default UserDetailsSection;
